/* eslint-disable @typescript-eslint/no-unused-vars */


/**
 * Represents a convention.  Conventions are a tangible way of representing interfaces.  Interfaces in TypeScript
 * are purely syntactical and are not available in any form during the compiled code.  Conventions are essentially
 * a way of tagging a component to indicate that it implements an interface of some kind and can be cast and
 * manipulated as an instance of said interface.  For example, we cannot do `if (obj instanceof MyInterface)` but
 * we can do `obj.is(MyConvention)`.  `is` and `as` methods are available on the base `Component` class for use
 * in this way.
 */
export class Convention<T = any> {

    /**
     * A globally unique value that represents the convention.
     */
    public readonly value: symbol;

    /**
     * Defines a new convention with the specified name.
     *
     * @param name
     */
    constructor(name: string) {
        this.value = Symbol(name);
    }

    public toString(): string {
        return this.value.description;
    }
}
